import React, { PureComponent } from 'react';
import RichTextEditor from 'react-rte';
import {Helmet} from "react-helmet";
import { Container, Col, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import foundryImg from '../../images/foundry1_min.jpg';
import msgs from '../../config/messages';
import BannerHOC from './BannerHOC';

import './Banner.scss';

class Banner extends PureComponent {
  static propTypes = {
    bannerText: PropTypes.string.isRequired,
    uploadBanner: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    // why give auth here you ask? see line 37 in HOC for reason
    // eslint-disable-next-line
    auth: PropTypes.shape({
      jwtToken: PropTypes.string,
      expiration: PropTypes.number,
      organizationId: PropTypes.string,
    }).isRequired,
  };

  render() {
    const { bannerText, uploadBanner, handleChange } = this.props;    
    return (
      <div className="nf-home">
      <Helmet>
          <meta charSet="utf-8" />
          <title>NFFS ICON - Banner Page</title>     
      </Helmet>  
        <section
          className="nf-home__section--landing"
          style={{ backgroundImage: `url(${foundryImg})` }}
        >
          <div className="nf-home__bg-layer">
            {/* <!-- CONTENT --> */}
            <Container>
              <Row>
                <Col sm={{ size: 10, offset: 1 }}>
                  <div className="nf-home__section-content text-center">
                    <h1 className="nf-home__header">
                      {msgs.HomePage.mainHeader}
                    </h1>
                    <p className="nf-home__subheader">
                      {msgs.HomePage.subHeader}
                    </p>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col sm={12}>
                  <div className="nf-home__section-content text-center">
                    <RichTextEditor
                      value={bannerText}
                      // type="text"
                      className="ghost-input"
                      // placeholder="What would you like the banner to say?"
                      onChange={handleChange}
                      onBlur={uploadBanner}
                    />
                  </div>
                </Col>
              </Row>
            </Container>

            {/* <!-- FLOATING DOWN ARROW --> */}
          </div>
        </section>
      </div>
    );
  }
}

export default BannerHOC(Banner);



// WEBPACK FOOTER //
// ./src/pages/Banner/Banner.jsx